import { type AppAbility, defineAbility } from '@carii/casl-abilities';
import {
  Can,
  AbilityProvider as CaslAbilityProvider,
  useAbility as useCaslAbility,
} from '@casl/react';
import type { ReactNode } from 'react';

export { Can };

interface AbilityProviderProps {
  ability: AppAbility;
  children: ReactNode;
}

export function AbilityProvider({ ability, children }: AbilityProviderProps) {
  return <CaslAbilityProvider value={ability}>{children}</CaslAbilityProvider>;
}

export function useAbility(): AppAbility {
  try {
    return useCaslAbility<AppAbility>();
  } catch {
    return defineAbility(null);
  }
}
